import createReactComponent from '../createReactComponent';
export default createReactComponent('loader-2', 'IconLoader2', [
  ['path', { d: 'M12 3a9 9 0 1 0 9 9', key: 'svg-0' }],
]);
